<template>
  <div class="step2">
    <div class="step" :class="activeClass" data-qa="step1-container">
      <div class="font-medium text-xl lg1024:text-3xl" data-qa="step1-title">
        {{ $t('unauth_step2') }}
      </div>
      <div class="stepContent">
        <FioBlock
          ref="fioBlockRef"
          :fields="userInfo"
          :profile-address-comment="profileAddressComment"
          :should-check-duplicates="shouldCheckDuplicates"
          :duplicate-check-loading="duplicateCheckLoading"
          :must-edit-field="mustEditField"
          @fields="onFields"
          @isValid="onValid"
          @update:profileAddressComment="onUpdateProfileAddressComment"
          @checkDuplicate="onCheckDuplicate"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import FioBlock from './components/FioBlock.vue'

const props = defineProps({
  step: Number,
  modelValue: { type: Object, required: true }, // userInfo
  profileAddressComment: { type: String, default: '' },
  shouldCheckDuplicates: { type: Boolean, default: false },
  duplicateCheckLoading: { type: Boolean, default: false },
  mustEditField: { type: Boolean, default: false },
})

const emit = defineEmits([
  'update:modelValue',
  'update:isValid',
  'update:profileAddressComment',
  'checkDuplicate',
])

const store = useStore()
const fioBlockRef = ref(null)

const lastProfile = computed(() => {
  return {
    FIO: store.state.SELECTED_PROFILE?.ADDRESS_INFO_FIELDS?.FIO || '',
    PHONE: store.state.SELECTED_PROFILE?.ADDRESS_INFO_FIELDS?.PHONE || '',
    EMAIL: store.state.SELECTED_PROFILE?.ADDRESS_INFO_FIELDS?.EMAIL || '',
  }
})

const hasUserInput = computed(
  () =>
    !!(props.modelValue.FIO || props.modelValue.PHONE || props.modelValue.EMAIL)
)

const userInfo = computed(() =>
  hasUserInput.value ? props.modelValue : lastProfile.value
)

const activeClass = computed(() => {
  return {
    active: props.step >= 2,
  }
})

const profileAddressComment = computed(() => props.profileAddressComment)

const onFields = (fields) => {
  emit('update:modelValue', fields)
}
const onValid = (isValid) => {
  emit('update:isValid', isValid)
}
const onUpdateProfileAddressComment = (value) => {
  emit('update:profileAddressComment', value)
}
const onCheckDuplicate = () => {
  emit('checkDuplicate')
}
// Метод для очистки поля (вызывается из родителя)
const clearField = (field) => {
  fioBlockRef.value?.clearField?.(field)
}

defineExpose({ clearField })
</script>

<style scoped lang="scss"></style>
